import React from "react";
import PropTypes from "prop-types";
import Modal from "../Modal";
import "./Sidebar.css";
import Link from "gatsby-link";

export class Sidebar extends React.Component {
  render() {
    const { show, onHide, Menu, activePathname } = this.props;
    return (
      <Modal direction="right" className="sidebar" show={show} onHide={onHide}>
        <Modal.Header>
          <span className="cross">
            <i onClick={onHide} className="fa fa-times" />
          </span>
        </Modal.Header>
        <Modal.Body>
          <div className="tabs">
            <ul className="">
              {Menu.map((item) => {
                return (
                  <li
                    key={item.title}
                    onClick={onHide}
                    className={`menu__text${
                      `/${activePathname}` === item.link ? "-active" : ""
                    }`}
                  >
                    <Link to={item.link}>{item.title}</Link>
                  </li>
                );
              })}
              <div className="social__header">
                <div className="social__icons">
                  <span className="icon">
                    <a
                      rel="noopener noreferrer"
                      href="https://www.facebook.com/bawamasalacompany"
                      target="_blank"
                      className=""
                    >
                      <i className="fa-brands fa-facebook" />
                    </a>
                  </span>
                  <span className="icon">
                    <a
                      rel="noopener noreferrer"
                      href="https://www.instagram.com/bawamasalacompany/"
                      target="_blank"
                      className=""
                    >
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </span>
                  <span className="icon">
                    <a
                      rel="noopener noreferrer"
                      href="https://twitter.com/bawamasalaco"
                      target="_blank"
                      className=""
                    >
                      <i className="fa-brands fa-x-twitter" />
                    </a>
                  </span>
                  <span className="icon">
                    <a
                      rel="noopener noreferrer"
                      href="https://www.linkedin.com/company/18855306/admin/overview/"
                      target="_blank"
                      className=""
                    >
                      <i className="fa-brands fa-linkedin" />
                    </a>
                  </span>
                  <span className="icon">
                    <a
                      rel="noopener noreferrer"
                      href="https://www.youtube.com/channel/UCWX7VFCNfrmjeXaAqYtyoQA?view_as=subscriber"
                      target="_blank"
                      className=""
                    >
                      <i className="fa-brands fa-youtube" />
                    </a>
                  </span>
                </div>
              </div>
            </ul>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

Sidebar.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  activePathname: PropTypes.string,
  Menu: PropTypes.array,
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js